const customer2_surname_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATECUST2SURNAME':
			return typeof action.payload !== "undefined" ? action.payload : "";

		default:
			return state;
	}
}

export default customer2_surname_reducer;